import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useLazyAssignmentGet = () => {
  const createResource = useCallback(({ id, queryParams = {}, skip }) => {
    if (skip) return undefined;

    const resource = `${MONOLITH_ORIGIN}/api/v3/assignment/${id}/`;
    const queryString = stringifyParams(queryParams);
    return `${resource}${queryString}`;
  }, []);
  return useLazyRestQuery(createResource);
};

export default useLazyAssignmentGet;
